/**
 * Spanish Postal Codes - Hybrid Approach
 * 
 * This file contains ONLY multi-city postal codes that require user selection.
 * All other postal codes are resolved via Zippopotam.us API.
 * 
 * This approach is scalable to Europe and worldwide.
 */

// Multi-city postal codes in Spain (user must select the correct city)
export const MULTI_CITY_POSTAL_CODES = {
  // BARCELONA PROVINCE
  '08720': {
    cities: [
      { city: 'Vilafranca del Penedès', lat: 41.3467, lng: 1.6969 },
      { city: 'El Pla del Penedès', lat: 41.3589, lng: 1.7123 },
      { city: 'La Granada', lat: 41.3612, lng: 1.7256 },
      { city: 'Les Cabanyes', lat: 41.3534, lng: 1.7089 },
      { city: 'Font-rubí', lat: 41.4012, lng: 1.6534 }
    ],
    province: 'Barcelona',
    area: 'Cataluña'
  },
  '08739': {
    cities: [
      { city: 'Subirats', lat: 41.3978, lng: 1.7834 },
      { city: 'Sant Pau d\'Ordal', lat: 41.3856, lng: 1.7912 }
    ],
    province: 'Barcelona',
    area: 'Cataluña'
  },
  '08785': {
    cities: [
      { city: 'Vallbona d\'Anoia', lat: 41.5123, lng: 1.5234 },
      { city: 'Cabrera d\'Igualada', lat: 41.5089, lng: 1.5178 }
    ],
    province: 'Barcelona',
    area: 'Cataluña'
  },
  // MADRID PROVINCE
  '28200': {
    cities: [
      { city: 'San Lorenzo de El Escorial', lat: 40.5889, lng: -4.1478 },
      { city: 'El Escorial', lat: 40.5823, lng: -4.1234 }
    ],
    province: 'Madrid',
    area: 'Comunidad de Madrid'
  },
  '28660': {
    cities: [
      { city: 'Boadilla del Monte', lat: 40.4056, lng: -3.8756 },
      { city: 'Brunete', lat: 40.4012, lng: -3.8912 }
    ],
    province: 'Madrid',
    area: 'Comunidad de Madrid'
  },
  // VALENCIA PROVINCE
  '46340': {
    cities: [
      { city: 'Requena', lat: 39.4878, lng: -1.1012 },
      { city: 'Utiel', lat: 39.5678, lng: -1.2034 }
    ],
    province: 'Valencia',
    area: 'Comunidad Valenciana'
  },
  // ALICANTE PROVINCE
  '03590': {
    cities: [
      { city: 'Altea', lat: 38.5989, lng: -0.0512 },
      { city: 'Altea la Vella', lat: 38.6034, lng: -0.0423 }
    ],
    province: 'Alicante',
    area: 'Comunidad Valenciana'
  },
  // MALAGA PROVINCE
  '29600': {
    cities: [
      { city: 'Marbella', lat: 36.5102, lng: -4.8824 },
      { city: 'San Pedro Alcántara', lat: 36.4878, lng: -4.9912 }
    ],
    province: 'Málaga',
    area: 'Andalucía'
  },
  // SEVILLA PROVINCE
  '41700': {
    cities: [
      { city: 'Dos Hermanas', lat: 37.2834, lng: -5.9212 },
      { city: 'Montequinto', lat: 37.3112, lng: -5.9334 }
    ],
    province: 'Sevilla',
    area: 'Andalucía'
  },
  // ISLAS BALEARES
  '07620': {
    cities: [
      { city: 'Llucmajor', lat: 39.4912, lng: 2.8912 },
      { city: 'S\'Arenal', lat: 39.5034, lng: 2.7534 }
    ],
    province: 'Illes Balears',
    area: 'Islas Baleares'
  },
  // TENERIFE
  '38600': {
    cities: [
      { city: 'Granadilla de Abona', lat: 28.1167, lng: -16.5833 },
      { city: 'El Médano', lat: 28.0500, lng: -16.5333 }
    ],
    province: 'Santa Cruz de Tenerife',
    area: 'Canarias'
  },
  // GRAN CANARIA
  '35100': {
    cities: [
      { city: 'Maspalomas', lat: 27.7606, lng: -15.5863 },
      { city: 'San Fernando', lat: 27.7701, lng: -15.5934 },
      { city: 'Playa del Inglés', lat: 27.7556, lng: -15.5745 }
    ],
    province: 'Las Palmas',
    area: 'Canarias'
  },
  // BIZKAIA
  '48900': {
    cities: [
      { city: 'Barakaldo', lat: 43.2956, lng: -2.9923 },
      { city: 'Sestao', lat: 43.3089, lng: -3.0078 }
    ],
    province: 'Bizkaia',
    area: 'País Vasco'
  },
  // GIRONA
  '17310': {
    cities: [
      { city: 'Lloret de Mar', lat: 41.7012, lng: 2.8456 },
      { city: 'Blanes', lat: 41.6745, lng: 2.7901 }
    ],
    province: 'Girona',
    area: 'Cataluña'
  }
};

// Province code to Comunidad Autónoma mapping
const PROVINCE_CODE_TO_AREA = {
  '01': 'País Vasco', '02': 'Castilla-La Mancha', '03': 'Comunidad Valenciana',
  '04': 'Andalucía', '05': 'Castilla y León', '06': 'Extremadura',
  '07': 'Islas Baleares', '08': 'Cataluña', '09': 'Castilla y León',
  '10': 'Extremadura', '11': 'Andalucía', '12': 'Comunidad Valenciana',
  '13': 'Castilla-La Mancha', '14': 'Andalucía', '15': 'Galicia',
  '16': 'Castilla-La Mancha', '17': 'Cataluña', '18': 'Andalucía',
  '19': 'Castilla-La Mancha', '20': 'País Vasco', '21': 'Andalucía',
  '22': 'Aragón', '23': 'Andalucía', '24': 'Castilla y León',
  '25': 'Cataluña', '26': 'La Rioja', '27': 'Galicia',
  '28': 'Comunidad de Madrid', '29': 'Andalucía', '30': 'Región de Murcia',
  '31': 'Navarra', '32': 'Galicia', '33': 'Asturias',
  '34': 'Castilla y León', '35': 'Canarias', '36': 'Galicia',
  '37': 'Castilla y León', '38': 'Canarias', '39': 'Cantabria',
  '40': 'Castilla y León', '41': 'Andalucía', '42': 'Castilla y León',
  '43': 'Cataluña', '44': 'Aragón', '45': 'Castilla-La Mancha',
  '46': 'Comunidad Valenciana', '47': 'Castilla y León', '48': 'País Vasco',
  '49': 'Castilla y León', '50': 'Aragón', '51': 'Ceuta',
  '52': 'Melilla'
};

// Province code to province name mapping
const PROVINCE_CODE_TO_NAME = {
  '01': 'Álava', '02': 'Albacete', '03': 'Alicante',
  '04': 'Almería', '05': 'Ávila', '06': 'Badajoz',
  '07': 'Illes Balears', '08': 'Barcelona', '09': 'Burgos',
  '10': 'Cáceres', '11': 'Cádiz', '12': 'Castellón',
  '13': 'Ciudad Real', '14': 'Córdoba', '15': 'A Coruña',
  '16': 'Cuenca', '17': 'Girona', '18': 'Granada',
  '19': 'Guadalajara', '20': 'Gipuzkoa', '21': 'Huelva',
  '22': 'Huesca', '23': 'Jaén', '24': 'León',
  '25': 'Lleida', '26': 'La Rioja', '27': 'Lugo',
  '28': 'Madrid', '29': 'Málaga', '30': 'Murcia',
  '31': 'Navarra', '32': 'Ourense', '33': 'Asturias',
  '34': 'Palencia', '35': 'Las Palmas', '36': 'Pontevedra',
  '37': 'Salamanca', '38': 'Santa Cruz de Tenerife', '39': 'Cantabria',
  '40': 'Segovia', '41': 'Sevilla', '42': 'Soria',
  '43': 'Tarragona', '44': 'Teruel', '45': 'Toledo',
  '46': 'Valencia', '47': 'Valladolid', '48': 'Bizkaia',
  '49': 'Zamora', '50': 'Zaragoza', '51': 'Ceuta',
  '52': 'Melilla'
};

/**
 * Get area (Comunidad Autónoma) from postal code
 */
export function getAreaFromPostalCode(postalCode) {
  const prefix = postalCode.substring(0, 2);
  return PROVINCE_CODE_TO_AREA[prefix] || '';
}

/**
 * Get province name from postal code
 */
export function getProvinceFromPostalCode(postalCode) {
  const prefix = postalCode.substring(0, 2);
  return PROVINCE_CODE_TO_NAME[prefix] || '';
}

/**
 * Check if postal code has multiple cities (local database)
 */
export function isMultiCityPostalCode(postalCode) {
  return MULTI_CITY_POSTAL_CODES.hasOwnProperty(postalCode);
}

/**
 * Get multi-city data for a postal code
 */
export function getMultiCityData(postalCode) {
  const data = MULTI_CITY_POSTAL_CODES[postalCode];
  if (!data) return null;
  
  return {
    hasMultipleCities: true,
    cities: data.cities.map(c => ({
      ...c,
      province: data.province,
      area: data.area
    })),
    province: data.province,
    area: data.area
  };
}

/**
 * Lookup postal code - checks local multi-city database first
 * Returns basic info if found locally, otherwise returns null for API lookup
 */
export function lookupPostalCode(postalCode) {
  // Check multi-city database first
  if (isMultiCityPostalCode(postalCode)) {
    const data = getMultiCityData(postalCode);
    return {
      found: true,
      ...data
    };
  }
  
  // Not in local database - will need API lookup
  return { found: false };
}

/**
 * Lookup via Zippopotam.us API (supports 60+ countries)
 * Then refine coordinates with Nominatim for better accuracy
 * @param {string} postalCode - The postal code to lookup
 * @param {string} countryCode - ISO 2-letter country code (es, it, de, fr, etc.)
 */
export async function lookupPostalCodeAPI(postalCode, countryCode = 'es') {
  try {
    const response = await fetch(
      `https://api.zippopotam.us/${countryCode.toLowerCase()}/${postalCode}`,
      { 
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      }
    );
    
    if (!response.ok) {
      return { found: false, error: 'not_found' };
    }
    
    const data = await response.json();
    
    if (data && data.places && data.places.length > 0) {
      const place = data.places[0];
      
      // If multiple places, check if they're different cities
      if (data.places.length > 1) {
        const uniqueCities = [...new Set(data.places.map(p => p['place name']))];
        if (uniqueCities.length > 1) {
          // Multiple different cities - get precise coordinates for each via Nominatim
          const citiesWithPreciseCoords = await Promise.all(
            data.places.map(async (p) => {
              const nominatimCoords = await getCoordinatesFromNominatim(p['place name'], postalCode, data.country);
              return {
                city: p['place name'],
                province: p['state'],
                lat: nominatimCoords.lat || parseFloat(p.latitude),
                lng: nominatimCoords.lng || parseFloat(p.longitude)
              };
            })
          );
          
          return {
            found: true,
            hasMultipleCities: true,
            cities: citiesWithPreciseCoords,
            province: place.state,
            area: getAreaFromPostalCode(postalCode),
            country: data.country,
            source: 'zippopotam+nominatim'
          };
        }
      }
      
      // Single city result - get precise coordinates via Nominatim
      const nominatimCoords = await getCoordinatesFromNominatim(place['place name'], postalCode, data.country);
      
      return {
        found: true,
        city: place['place name'],
        province: place.state,
        area: getAreaFromPostalCode(postalCode),
        lat: nominatimCoords.lat || parseFloat(place.latitude),
        lng: nominatimCoords.lng || parseFloat(place.longitude),
        country: data.country,
        source: nominatimCoords.lat ? 'zippopotam+nominatim' : 'zippopotam'
      };
    }
    
    return { found: false, error: 'no_places' };
  } catch (error) {
    console.error('Zippopotam API error:', error);
    return { found: false, error: 'api_error' };
  }
}

/**
 * Get precise coordinates from Nominatim using city name and postal code
 */
async function getCoordinatesFromNominatim(cityName, postalCode, country = 'Spain') {
  try {
    // Search with city name and postal code for more precise results
    const query = encodeURIComponent(`${cityName}, ${postalCode}, ${country}`);
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?q=${query}&format=json&limit=1`,
      { 
        headers: { 'User-Agent': 'TantraMap/1.0' }
      }
    );
    
    if (!response.ok) {
      return { lat: null, lng: null };
    }
    
    const data = await response.json();
    
    if (data && data.length > 0) {
      return {
        lat: parseFloat(data[0].lat),
        lng: parseFloat(data[0].lon)
      };
    }
    
    return { lat: null, lng: null };
  } catch (error) {
    console.error('Nominatim coordinates lookup error:', error);
    return { lat: null, lng: null };
  }
}

/**
 * Fallback lookup via OpenStreetMap Nominatim
 */
export async function lookupPostalCodeNominatim(postalCode, country = 'Spain') {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?postalcode=${postalCode}&country=${country}&format=json&limit=1`,
      { 
        headers: { 'User-Agent': 'TantraMap/1.0' }
      }
    );
    
    if (!response.ok) {
      return { found: false, error: 'nominatim_error' };
    }
    
    const data = await response.json();
    
    if (data && data.length > 0) {
      const result = data[0];
      const parts = result.display_name.split(', ');
      const city = parts[0] || '';
      
      return {
        found: true,
        city: city,
        province: getProvinceFromPostalCode(postalCode),
        area: getAreaFromPostalCode(postalCode),
        lat: parseFloat(result.lat),
        lng: parseFloat(result.lon),
        source: 'nominatim'
      };
    }
    
    return { found: false, error: 'not_found' };
  } catch (error) {
    console.error('Nominatim API error:', error);
    return { found: false, error: 'api_error' };
  }
}

/**
 * Country code mapping for Zippopotam.us API
 */
export const COUNTRY_CODES = {
  'españa': 'es', 'spain': 'es', 'spagna': 'es',
  'italia': 'it', 'italy': 'it',
  'francia': 'fr', 'france': 'fr',
  'alemania': 'de', 'germany': 'de', 'germania': 'de',
  'portugal': 'pt',
  'reino unido': 'gb', 'united kingdom': 'gb', 'uk': 'gb',
  'estados unidos': 'us', 'united states': 'us', 'usa': 'us',
  'países bajos': 'nl', 'netherlands': 'nl', 'holanda': 'nl',
  'bélgica': 'be', 'belgium': 'be', 'belgio': 'be',
  'suiza': 'ch', 'switzerland': 'ch', 'svizzera': 'ch',
  'austria': 'at',
  'polonia': 'pl', 'poland': 'pl',
  'suecia': 'se', 'sweden': 'se',
  'noruega': 'no', 'norway': 'no',
  'dinamarca': 'dk', 'denmark': 'dk',
  'finlandia': 'fi', 'finland': 'fi',
  'irlanda': 'ie', 'ireland': 'ie',
  'grecia': 'gr', 'greece': 'gr',
  'república checa': 'cz', 'czech republic': 'cz',
  'hungría': 'hu', 'hungary': 'hu',
  'rumania': 'ro', 'romania': 'ro',
  'bulgaria': 'bg',
  'croacia': 'hr', 'croatia': 'hr',
  'eslovenia': 'si', 'slovenia': 'si',
  'eslovaquia': 'sk', 'slovakia': 'sk',
  'luxemburgo': 'lu', 'luxembourg': 'lu',
  'malta': 'mt',
  'chipre': 'cy', 'cyprus': 'cy',
  'estonia': 'ee',
  'letonia': 'lv', 'latvia': 'lv',
  'lituania': 'lt', 'lithuania': 'lt',
  'canadá': 'ca', 'canada': 'ca',
  'méxico': 'mx', 'mexico': 'mx',
  'brasil': 'br', 'brazil': 'br',
  'argentina': 'ar',
  'australia': 'au',
  'japón': 'jp', 'japan': 'jp',
  'india': 'in',
  'sudáfrica': 'za', 'south africa': 'za'
};

/**
 * Get country code from country name
 */
export function getCountryCode(countryName) {
  const normalized = countryName.toLowerCase().trim();
  return COUNTRY_CODES[normalized] || 'es';
}

/**
 * Countries available for selection (expandable)
 */
export const AVAILABLE_COUNTRIES = [
  { code: 'ES', name: 'España', apiCode: 'es' },
  { code: 'IT', name: 'Italia', apiCode: 'it' },
  { code: 'FR', name: 'Francia', apiCode: 'fr' },
  { code: 'DE', name: 'Alemania', apiCode: 'de' },
  { code: 'PT', name: 'Portugal', apiCode: 'pt' },
  { code: 'GB', name: 'Reino Unido', apiCode: 'gb' },
  { code: 'NL', name: 'Países Bajos', apiCode: 'nl' },
  { code: 'BE', name: 'Bélgica', apiCode: 'be' },
  { code: 'CH', name: 'Suiza', apiCode: 'ch' },
  { code: 'AT', name: 'Austria', apiCode: 'at' },
  { code: 'PL', name: 'Polonia', apiCode: 'pl' },
  { code: 'SE', name: 'Suecia', apiCode: 'se' },
  { code: 'NO', name: 'Noruega', apiCode: 'no' },
  { code: 'DK', name: 'Dinamarca', apiCode: 'dk' },
  { code: 'FI', name: 'Finlandia', apiCode: 'fi' },
  { code: 'IE', name: 'Irlanda', apiCode: 'ie' },
  { code: 'GR', name: 'Grecia', apiCode: 'gr' },
  { code: 'CZ', name: 'República Checa', apiCode: 'cz' },
  { code: 'HU', name: 'Hungría', apiCode: 'hu' },
  { code: 'RO', name: 'Rumania', apiCode: 'ro' },
  { code: 'BG', name: 'Bulgaria', apiCode: 'bg' },
  { code: 'HR', name: 'Croacia', apiCode: 'hr' },
  { code: 'US', name: 'Estados Unidos', apiCode: 'us' },
  { code: 'CA', name: 'Canadá', apiCode: 'ca' },
  { code: 'MX', name: 'México', apiCode: 'mx' },
  { code: 'BR', name: 'Brasil', apiCode: 'br' },
  { code: 'AR', name: 'Argentina', apiCode: 'ar' },
  { code: 'AU', name: 'Australia', apiCode: 'au' }
];

// Legacy exports for backward compatibility
export const SPANISH_POSTAL_CODES = MULTI_CITY_POSTAL_CODES;
export const CITY_TO_POSTAL_CODES = {};

export function lookupCity(cityName) {
  // This is now a simplified version - for full city lookup, use the API
  return { found: false };
}

export function findNearestPostalCodes(code) {
  // No longer needed with API approach
  return [];
}
